import React, { useMemo } from "react";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { APICardComponent, ComponentData } from "@companion-core/shared/app/Interfaces/API";
import { VisualBannerLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/VisualBannerLayout";
import {
  getComponentMedia,
  getComponentsCard,
  getComponentsFromBlockItems,
} from "@companion-core/shared/app/Utils/componentHelper";

export const VisualBanner = ({ simpleBlockItems }: BlockProps) => {
  const simpleComponents: ComponentData[] = useMemo(
    () => getComponentsFromBlockItems(simpleBlockItems),
    [simpleBlockItems]
  );

  const visualUrl: string | undefined = useMemo(
    () => getComponentMedia(simpleComponents)?.medias?.[0]?.url,
    [simpleComponents]
  );
  const visualDescriptionAlt: string | undefined = useMemo(
    () => getComponentMedia(simpleComponents)?.medias?.[0]?.description_alt,
    [simpleComponents]
  );
  const cardComponent: APICardComponent = useMemo(
    () => getComponentsCard(simpleComponents)?.[0],
    [simpleComponents]
  );
  const backgroundUrl: string | undefined = useMemo(
    () => cardComponent?.medias?.[0]?.url,
    [simpleComponents]
  );
  const title: string = useMemo(() => cardComponent?.title ?? "", [simpleComponents]);

  return (
    <VisualBannerLayout
      title={title}
      backgroundUrl={backgroundUrl}
      visualUrl={visualUrl}
      visualDescriptionAlt={visualDescriptionAlt}
    />
  );
};
